import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Team.css";
import ceoImg from "../../assets/Ceo.png";
import hrImg from "../../assets/hr.png";

const Team = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="team-section" id="team">
      <h2 className="team-title" data-aos="fade-up">
        Our Leadership Team
        <span className="team-underline"></span>
      </h2>

      <div className="team-members">
        {/* CEO */}
        <div className="team-member" data-aos="fade-up" data-aos-delay="200">
          <img src={ceoImg} alt="CEO" />
          <h3>Vijay Bhargav</h3>
          <p className="team-role">Chief Executive Officer</p>
        </div>

        {/* HR */}
        <div className="team-member" data-aos="fade-left" data-aos-delay="400">
          <img src={hrImg} alt="HR" />
          <h3>Poorna Bindu</h3>
          <p className="team-role">Human Resources Manager</p>
        </div>
      </div>
    </section>
  );
};

export default Team;
